import React, { useState } from 'react'
import { map } from 'lodash'
import { useNotifications, useFileUpload, useAuth, useAnalytics } from 'hooks'
import useReportCreate from '../hooks/useReportCreate'
import useReportAddFile from '../hooks/useReportAddFile'
import useReportRun from '../hooks/useReportRun'
import FileUploadSelectStep from './FileUploadSelectStep'
import FileUploadSubmitStep from './FileUploadSubmitStep'
import TemplateStep from '../templates/TemplateStep'

export default function FileUploadReport({
  modal,
  step,
  onBack,
  onNext,
  uploadSource,
  currentTemplate,
  handleTemplateChange,
  configSections,
  setConfigSections,
  editing,
  defaultReportSections,
  defaultTemplate,
  organization,
}) {
  const { currentCompany } = useAuth()
  const [files, setFiles] = useState([])
  const [fileKinds, setFileKinds] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const [reportName, setReportName] = useState('')
  const notifications = useNotifications()
  const [createReport] = useReportCreate()
  const [addReportFile] = useReportAddFile()
  const [runReport] = useReportRun()
  const [uploadFiles, { progress }] = useFileUpload()
  const analytics = useAnalytics()

  const handleCreate = async () => {
    setSubmitting(true)

    const { report } = await createReport({
      companyId: currentCompany.id,
      kind: 'anomaly:1',
      name: reportName,
      config: { sections: configSections },
    })

    // build file descriptors
    const descriptors = map(fileKinds, (file, kind) => ({ kind, file }))

    // upload files
    const uploadResults = await uploadFiles(`reports/${report.rowId}/source`, descriptors)

    // create report inputs
    for (let i = 0; i < uploadResults.length; i++) {
      await addReportFile({
        type: 'SOURCE',
        reportId: report.rowId,
        userFileId: uploadResults[i].id,
      })
    }

    // // call the runReport lambda, but don't wait for it since
    // // we'll get updates via report subscription
    runReport({ reportId: report.id })

    analytics.track('Report Created', { reportId: report.rowId })
    notifications.info('Report created.')
    modal.onClose({ force: true })
  }

  const steps = [FileUploadSelectStep, TemplateStep, FileUploadSubmitStep]
  const StepComponent = steps[step - 2]

  return (
    <StepComponent
      onClose={modal.onClose}
      onBack={onBack}
      onNext={onNext}
      onDone={handleCreate}
      files={files}
      setFiles={setFiles}
      fileKinds={fileKinds}
      setFileKinds={setFileKinds}
      reportName={reportName}
      setReportName={setReportName}
      progress={progress}
      submitting={submitting}
      uploadSource={uploadSource}
      currentTemplate={currentTemplate}
      handleTemplateChange={handleTemplateChange}
      configSections={configSections}
      setConfigSections={setConfigSections}
      editing={editing}
      closeAllOtherModals={modal.closeAllOtherModals}
      defaultReportSections={defaultReportSections}
      defaultTemplate={defaultTemplate}
      organization={organization}
    />
  )
}
